import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import _ from "lodash";

import RenderPreviewByType from "../RenderPreviewByType";

import { Form, Input, Button, Radio, Tooltip, Modal, notification } from "antd";
import { FolderViewOutlined, InfoCircleOutlined } from "@ant-design/icons";
import SlideLibrary from "../../../SlideLibrary/Index";
import EditMedia from "../../../MediaLibrary/EditMedia";
import Config from "../../../../../../config/frontend";
import parseMediaUrl from "../../../../../shared/functions/parseMediaUrl";
import urlParse from "url-parse";
import { t } from "i18next";

const InputField = (props) => {
  const { mediaValue } = props;
  useEffect(() => {
    props.onChange(mediaValue);
  }, [mediaValue]);
  return (
    <div className="slide-list-container">
      {props.value?.map((value, index) => (
        <Input key={index} value={value} />
      ))}
    </div>
  );
};

export const InputSlide = (props) => {
  const { item, form, skipForm, feedType, hidePreview = false, setVisibleEdit = undefined } = props;
  const { labelImage } = item;
  const [openMediaLibrary, setOpenMediaLibrary] = useState(false);
  const [mediaValue, setMediaValue] = useState(item.value);

  useEffect(() => {
    if (hidePreview) {
      setOpenMediaLibrary(true);
    }
  }, [hidePreview]);

  const openModal = (e) => {
    setOpenMediaLibrary(!openMediaLibrary);
    hidePreview && setVisibleEdit(false)

  };
  useEffect(() => {
    if (item.value) {
      setMediaValue(item.value);
    }
  }, [item.value]);

  const mediaUrls = mediaValue?.map((val) =>
    parseMediaUrl(_.get(val, "url", "")),
  );

  return (
    <div className={"form-input-media"}>
      {
        <Form.Item label={hidePreview ? "" : item.label} tooltip={props.tooltip}>
          {!skipForm && (
            <Form.Item name={item.id} noStyle hidden>
              <InputField mediaValue={mediaValue} />
            </Form.Item>
          )}

          {!hidePreview ? (mediaUrls && mediaUrls?.length > 0) ? (
            <div className="media-preview-block" onClick={openModal}>
              {mediaUrls.map((mediaUrl, index) => (
                <RenderPreviewByType
                  key={mediaUrl + item.updatedAt}
                  url={mediaUrl}
                  item={mediaValue}
                />
              ))}
            </div>
          ) : (
            <div onClick={openModal}>
              <Tooltip className={"open-media-library"} title="Media library">
                <FolderViewOutlined className={"media-preview-empty"} />
              </Tooltip>
            </div>
          ) : (<></>)}
        </Form.Item>
      }


      <Modal
        title="Media"
        centered
        open={openMediaLibrary}
        onOk={() => openModal(false)}
        onCancel={() => openModal(false)}
        maskClosable={false}
        width={1800}
        styles={{
          body: {
            height: window.innerHeight - 100,
          },
        }}
      >
        <SlideLibrary
          onSelect={(e, selectedItem) => {
            if (!skipForm) {
              if (mediaValue.length > 19) {
                notification["error"]({
                  message: t("Warning"),
                  description: t("Max image count exceeded!"),
                  placement: "topRight",
                });
                return;
              }
              const prevMedias = [...mediaValue];
              const { uuid } = selectedItem;
              const exist = prevMedias.find((media) => media.uuid === uuid);
              if (exist) {
              } else {
                setMediaValue([...prevMedias, selectedItem]);
              }
            }
          }}
          handleRemoveFromSlide={(item) => {
            if (!skipForm) {
              const prevMedias = [...mediaValue];
              const { uuid } = item;
              const newMedias = prevMedias.filter(
                (media) => media.uuid !== uuid,
              );
              setMediaValue(newMedias);
            }
          }}
          openEditSlideItem={(e, item) => { }}
          onOrderChange={(items) => {
            setMediaValue(items);
          }}
          onSlideItemChange={(item) => {
            const allItems = [...mediaValue];
            const foundItem = allItems.find(
              (_item) => _item.uuid === item.uuid,
            );
            const { changed } = item;
            const keys = Object.keys(changed);
            const key = keys[0];
            foundItem[key] = changed[key];
            setMediaValue(allItems);
          }}
          item={item}
          initialActiveGroup={_.get(item, "initialActiveGroup", null)}
          slides={mediaValue}
          feedType={feedType}
        />
      </Modal>
    </div>
  );
};
